module.exports = __webpack_public_path__ + "img/company.150b04e5.png";